import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Cell, Loader, Spacer, Text, EmptyState, Label, Divider, Animation } from '@vinted/web-ui';
import { UiState } from 'constants/ui';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { InfoBannerScreen } from 'constants/info-banner';
import { STATIC_ASSETS_URL } from 'constants/index';
import { FormattedMessage } from 'components/@support';
import InfiniteScroll from 'components/InfiniteScroll';
import Banner from 'components/Banner';
import InfoBanner from 'components/InfoBanner';
import SeparatedList from 'components/SeparatedList';
import { actions } from 'state/user-feedback/slice';
import * as selectors from 'state/user-feedback/selectors';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import FeedbackItem from './FeedbackItem';
import FeedbackSummary from './FeedbackSummary';
import FeedbackFilters from './FeedbackFilters/FeedbackFilters';
import { FeedbackFilterType } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const mapStateToProps = state => ({
  feedbackIds: selectors.getFeedbackIds(state),
  uiState: selectors.getUiState(state),
  endReached: selectors.getEndReached(state),
  isTransparentFeedbackEnabled: getIsFeatureSwitchEnabled('web_transparent_autofeedback')(state),
  showFilters: selectors.getShowFilters(state)
});

const mapActionsToProps = {
  feedbackGetRequest: actions.feedbackGetRequest,
  feedbackClearIds: actions.feedbackClearIds,
  feedbackResetCurrentPage: actions.feedbackResetCurrentPage
};
const connector = connect(mapStateToProps, mapActionsToProps);

class ProfileFeedback extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      selectedFeedbackFilterType: FeedbackFilterType.All
    });

    _defineProperty(this, "fetchFeedback", () => {
      const {
        feedbackGetRequest,
        userId,
        endReached
      } = this.props;
      const {
        selectedFeedbackFilterType
      } = this.state;
      if (!endReached) feedbackGetRequest({
        userId,
        feedbackFilterType: selectedFeedbackFilterType
      });
    });

    _defineProperty(this, "translate", (id, values) => /*#__PURE__*/_jsx(FormattedMessage, {
      id: "user.feedback.".concat(id),
      values: values
    }));

    _defineProperty(this, "showEmptyState", () => {
      const {
        uiState,
        endReached,
        feedbackIds
      } = this.props;
      return uiState !== UiState.Pending && endReached && !feedbackIds.length;
    });

    _defineProperty(this, "renderFeedbackItem", () => {
      const {
        feedbackIds,
        userId,
        isContentTranslationEnabled
      } = this.props;
      return feedbackIds.map((id, index) => /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(FeedbackItem, {
          id: id,
          userId: userId,
          isContentTranslationEnabled: isContentTranslationEnabled
        }), index !== feedbackIds.length - 1 && /*#__PURE__*/_jsx("div", {
          className: "u-ui-margin-vertical-medium",
          children: /*#__PURE__*/_jsx(Divider, {})
        })]
      }, id));
    });

    _defineProperty(this, "handleFilterChipClicked", feedbackFilterType => {
      const {
        feedbackClearIds,
        feedbackResetCurrentPage
      } = this.props;
      this.setState({
        selectedFeedbackFilterType: feedbackFilterType
      });
      feedbackResetCurrentPage();
      feedbackClearIds();
    });
  }

  renderEmptyState() {
    if (!this.showEmptyState()) return null;
    return /*#__PURE__*/_jsx(EmptyState, {
      animation: /*#__PURE__*/_jsx(Animation, {
        animationUrl: "".concat(STATIC_ASSETS_URL, "/assets/animations/performance-empty-state.json")
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "user.feedback.empty_state.title"
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "user.feedback.empty_state.body"
      })
    });
  }

  renderFeedbackBanner() {
    const {
      canAddFeedback,
      leaveFeedbackUrl
    } = this.props;
    if (!canAddFeedback || !leaveFeedbackUrl) return null;
    return /*#__PURE__*/_jsx(Banner, {
      title: /*#__PURE__*/_jsx(Text, {
        text: this.translate('had_a_deal'),
        type: Text.Type.Title
      }),
      body: /*#__PURE__*/_jsx(Text, {
        text: this.translate('leave_feedback_about_deal')
      }),
      actions: [/*#__PURE__*/_jsx(Button, {
        styling: Button.Styling.Filled,
        text: this.translate('leave_feedback'),
        url: leaveFeedbackUrl
      })]
    });
  }

  renderReadMoreBlock() {
    const {
      readMoreUrl,
      isTransparentFeedbackEnabled
    } = this.props;
    if (!readMoreUrl) return null;
    return /*#__PURE__*/_jsx(Label, {
      type: Label.Type.Leading,
      text: this.translate('most_recent'),
      suffix: !isTransparentFeedbackEnabled && /*#__PURE__*/_jsx("a", {
        className: "u-disable-underline",
        href: readMoreUrl,
        children: this.translate('read_more')
      })
    });
  }

  renderLoader() {
    const {
      uiState
    } = this.props;
    if (uiState !== UiState.Pending) return null;
    return /*#__PURE__*/_jsx("div", {
      className: "u-flexbox u-justify-content-center",
      children: /*#__PURE__*/_jsx(Loader, {
        size: Loader.Size.Large
      })
    });
  }

  renderFeedbackContent() {
    const {
      feedbackIds
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [this.renderReadMoreBlock(), /*#__PURE__*/_jsxs(Cell, {
        children: [/*#__PURE__*/_jsx(InfiniteScroll, {
          renderItems: this.renderFeedbackItem,
          onPageEnd: this.fetchFeedback,
          cursor: "feedback-".concat(feedbackIds.length)
        }), this.renderLoader()]
      })]
    });
  } // TODO: convert into functional component
  // eslint-disable-next-line class-methods-use-this


  renderInfoBanner() {
    const TargetBanner = InfoBanner;
    const target = ClickableElement.MergeReviewsBanner;
    return /*#__PURE__*/_jsx(TargetBanner, {
      screen: InfoBannerScreen.Reviews,
      linkTracking: {
        target
      }
    });
  }

  renderHeader() {
    const {
      username,
      showTitle
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [this.renderInfoBanner(), showTitle && /*#__PURE__*/_jsx(Text, {
        type: Text.Type.Heading,
        children: this.translate('title', {
          username
        })
      })]
    });
  }

  render() {
    return /*#__PURE__*/_jsxs(SeparatedList, {
      separator: /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.Large
      }),
      children: [this.renderHeader(), this.renderFeedbackBanner(), /*#__PURE__*/_jsx(FeedbackSummary, {
        userId: this.props.userId
      }), /*#__PURE__*/_jsx(FeedbackFilters, {
        selectedFeedbackFilterType: this.state.selectedFeedbackFilterType,
        showFilters: this.props.showFilters,
        onClick: this.handleFilterChipClicked
      }), this.renderEmptyState() || this.renderFeedbackContent()]
    });
  }

}

export default connector(ProfileFeedback);